import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { HomeService } from "../home/home.services";
import { ToastMessageService } from "src/app/toastr.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import * as _ from "lodash";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-filessalesandvolume",
  templateUrl: "./filessalesandvolume.component.html",
  styleUrls: ["./filessalesandvolume.component.scss"],
})
export class FilessalesandvolumeComponent implements OnInit {
  @ViewChild("UploadFileInput", { static: false }) uploadFileInput: ElementRef;
  submolecules: any[];
  subMolecule = false;
  Molecule = false;
  DragData: any = {};
  selectedSubMolecule: any;
  showedit = false;
  noData = false;
  brandname = "";
  sliceEnd = 5;
  ProductData;
  allMoleculeData;
  SalesVolumeData;
  SalesData;
  SalesReportData;
  saveData;
  DosageForms;
  VolumeStregnth;
  nda_number: any;
  Stregnth;
  MoleculeData1;
  fileUploadForm: FormGroup;
  fileInputLabel: string;
  Object = Object;
  volume;
  salesheader;
  volumeheader;
  MGData;
  SalesmainArr;
  updateSaleArr;
  VolumemainArr;
  VData;
  strength;
  paramsValues: any;
  searchValue: any;
  arrSales: any[] = [];
  arrVolume: any[] = [];
  email: any;
  constructor(
    private toastService: ToastMessageService,
    private homeservice: HomeService,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.paramsValues = this.route.snapshot.queryParams;
    if (this.paramsValues.brand_name && this.paramsValues.nda) {
      this.brandname = this.paramsValues.brand_name
      this.searchMolecule1()
      // this.selectedSubMolecule = { code: 'MEKINIST,204114', name: 'MEKINIST,204114' }
      this.selectedSubMolecule = { code: (`${this.paramsValues.brand_name},${this.paramsValues.nda}`), name: (`${this.paramsValues.brand_name},${this.paramsValues.nda}`) }
      this.searchMolecule()
    }
    this.fileUploadForm = this.formBuilder.group({
      myfile: [""],
    });
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  searchMolecule1() {
    this.submolecules = [];
    let brand_name = this.brandname;
    console.log(brand_name);
    this.homeservice.GetNda(brand_name).subscribe((response) => {
      this.MoleculeData1 = response["data"].nda_numbers;
      if (this.MoleculeData1 != null) {
        let dropdownvalues = this.arrayToDropdown(this.MoleculeData1);
        this.submolecules = dropdownvalues;
        const Array = this.submolecules[0].name.split(",")[1];
        this.nda_number = Array;
        this.subMolecule = true;
        this.Molecule = false;
        this.DragData = {};
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
        this.DragData = {};
      }
    });
  }

  // searchMolecule() {
  //   if (this.selectedSubMolecule !== undefined) {
  //     let data = {
  //       nda_number: this.selectedSubMolecule["name"].split(",")[1],
  //       brand_name: this.selectedSubMolecule["name"].split(",")[0],
  //       user_email: this.email,
  //     };
  //     this.homeservice.SalesandVolume(data).subscribe((res) => {
  //       this.allMoleculeData = res["data"];
  //       let val = Object.keys(this.allMoleculeData);
  //       delete val[0];
  //       this.ProductData = res["data"]["product_data"];
  //       delete this.ProductData["Approval date / Action date (mm-dd-yyyy)"];

  //       let Salesarr = [
  //         this.allMoleculeData["5 year sales"]["value"]["Strengths (mg)"],
  //       ];
  //       let Volumearr = [
  //         this.allMoleculeData["5 year volume"]["value"]["Strengths (mg)"],
  //       ];

  //       this.VData = Object.keys(Salesarr[0]);
  //       this.MGData = Object.keys(Volumearr[0]);
  //       let Salesval = Object.values(Salesarr[0]);
  //       let Salesarr3 = [];
  //       for (let i = 0; i < Salesval.length; i++) {
  //         let Salesarr = Object.values(Salesval[i]);
  //         Salesarr3.push(Salesarr);
  //       }
  //       let Salesarr2 = [];
  //       for (let i = 0; i < Salesarr3.length; i++) {
  //         this.arrSales = Salesarr3[i];
  //         Salesarr2.push(this.arrSales);
  //       }
  //       this.SalesmainArr = Salesarr2;
  //       this.updateSaleArr = Salesarr2;

  //       let Volumeval = Object.values(Volumearr[0]);
  //       let Volumearr3 = [];
  //       for (let j = 0; j < Volumeval.length; j++) {
  //         let Volumearr = Object.values(Volumeval[j]);
  //         Volumearr3.push(Volumearr);
  //       }
  //       let Volumearr2 = [];
  //       for (let j = 0; j < Volumearr3.length; j++) {
  //         this.arrVolume = Volumearr3[j];
  //         Volumearr2.push(this.arrVolume);
  //       }
  //       this.VolumemainArr = Volumearr2;

  //       this.DosageForms = res["data"]["product_data"]["Dosage forms"];
  //       this.Stregnth = this.allMoleculeData["5 year sales"]["value"];
  //       this.saveData = delete this.allMoleculeData["product_data"];
  //       delete this.Stregnth["website"];
  //       for (let i = 0; i < Object.keys(this.allMoleculeData).length; i++) {
  //         this.strength = Object.keys(this.allMoleculeData);
  //       }
  //       this.SalesVolumeData =
  //         this.allMoleculeData["5 year sales"]["value"]["Strengths (mg)"];
  //       this.VolumeStregnth = this.allMoleculeData["5 year volume"]["value"];
  //       delete this.VolumeStregnth["website"];

  //       for (let i = 0; i < Object.values(this.SalesVolumeData).length; i++) {
  //         this.SalesData = Object.values(this.SalesVolumeData)[i];
  //       }

  //       var data = Object.keys(this.SalesData);
  //       for (let i = 0; i < data.length; i++) {
  //         this.volumeheader = data;
  //       }

  //       if (res["success"] == "200") {
  //         this.Molecule = true;
  //         this.toastService.success("Data Fetched Successfully");
  //         return;
  //       } else {
  //         this.toastService.error("Data Not Found !");
  //         return;
  //       }
  //     });
  //   }
  // }

  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }

  onFileSelect(event) {
    let af = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log(file);
      if (!_.includes(af, file.type)) {
        alert("Only EXCEL Allowed!");
      } else {
        this.fileInputLabel = file.name;
        this.fileUploadForm.get("myfile").setValue(file);
      }
    }
  }

  onFormSubmit() {
    if (!this.fileUploadForm.get("myfile").value) {
      alert("Please fill valid details!");
      return false;
    }
    const formData = new FormData();
    let data = {
      nda_number: this.selectedSubMolecule["name"].split(",")[1],
      brand_name: this.selectedSubMolecule["name"].split(",")[0],
      excel_sheet: this.fileUploadForm.get("myfile").value,
      user_email: this.email,
    };

    this.homeservice.uploadSalesExcel(data).subscribe((response) => {
      this.SalesReportData = response["not found data"];
      console.log(response["not found data"]);
      if ((response["success"] = 200)) {
        this.toastService.success("File uploaded sucessfully");
      }
    });
  }

  downloadSalesReports() {
    let dailyReport;
    let resp = this.SalesReportData;
    let file = this.fileInputLabel;

    const worksheet = XLSX.utils.json_to_sheet(resp);
    const workbook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, `${file}.xlsx`);
  }

  // toggleEditSave() {
  //   if (this.showedit) {
  //     this.Stregnth.forEach((row, index) => {
  //       this.saveMolecule(this.allMoleculeData, row['Strengths (mg)'], "5 year sales", index);
  //     });

  //     this.VolumeStregnth.forEach((row, index) => {
  //       this.saveMolecule(this.allMoleculeData, row['Strengths (mg)'], "5 year volume", index);
  //     });
  //   }

  //   this.showedit = !this.showedit;
  // }

  toggleEditSave() {
    if (this.showedit) {
      this.saveAllMoleculeData();  // ✅ Only one API call
    }

    this.showedit = !this.showedit;
  }


  saveAllMoleculeData() {
    const updatedSales = this.Stregnth.map((row, mainIndex) => {
      let updatedRow: any = {};

      this.salesheader.forEach((key, index) => {
        if (key === 'Strengths (mg)') {
          updatedRow[key] = row[key];
        } else if (key === 'Fill Volume/Weight (ml or gm)') {
          const val = row[key];
          updatedRow[key] = val;
        }
        else {
          const inputId = 'sales' + mainIndex + 'row' + index;
          const inputElement = <HTMLInputElement>document.getElementById(inputId);
          if (inputElement) {
            let val = parseFloat(inputElement.value || '0');
            updatedRow[key] = isNaN(val) ? 0 : val;
          } else {
            let val = row[key];
            let floatVal = parseFloat(val);
            updatedRow[key] = isNaN(floatVal) ? val : floatVal;
          }
        }
      });

      return updatedRow;
    });

    const updatedVolume = this.VolumeStregnth.map((row, mainIndex) => {
      let updatedRow: any = {};

      this.volumeheader.forEach((key, index) => {
        if (key === 'Strengths (mg)') {
          updatedRow[key] = row[key];
        } else if (key === 'Fill Volume/Weight (ml or gm)') {
          const val = row[key];
          updatedRow[key] = val;
        } else {
          const inputId = 'volume' + mainIndex + 'row' + index;
          const inputElement = <HTMLInputElement>document.getElementById(inputId);
          if (inputElement) {
            let val = parseFloat(inputElement.value || '0');
            updatedRow[key] = isNaN(val) ? 0 : val;
          } else {
            let val = row[key];
            let floatVal = parseFloat(val);
            updatedRow[key] = isNaN(floatVal) ? val : floatVal;
          }
        }
      });

      return updatedRow;
    });

    const finalData = {
      brand_name: this.selectedSubMolecule["name"].split(",")[0],
      nda_number: this.selectedSubMolecule["name"].split(",")[1],
      dosage_form: this.DosageForms,
      product_data: this.ProductData,
      "5 year sales": {
        value: updatedSales,
        website: "website0"
      },
      "5 year volume": {
        value: updatedVolume,
        website: "website0"
      }
    };

    console.log("🚀 Final Payload to Send →", finalData);
    localStorage.setItem("molecules", JSON.stringify(finalData));

    this.homeservice.UpdateSalesandVolume(finalData).subscribe(
      (response) => {
        console.log("response", response);

        this.toastService.success("Data updated successfully");

        const data = response["data"];
        this.allMoleculeData = data;
        this.Stregnth = data["5 year sales"]["value"];
        this.VolumeStregnth = data["5 year volume"]["value"];

        // Update headers based on latest structure (if needed)
        this.salesheader = Array.from(new Set(this.Stregnth.flatMap(obj => Object.keys(obj))));
        this.volumeheader = Array.from(new Set(this.VolumeStregnth.flatMap(obj => Object.keys(obj))));

        this.showedit = false;
      },
      (error) => {
        this.toastService.error(typeof error === "string" ? error : error.message);
        this.searchMolecule();
      }
    );
  }


  searchMolecule() {
    if (this.selectedSubMolecule !== undefined) {
      const data = {
        nda_number: this.selectedSubMolecule["name"].split(",")[1],
        brand_name: this.selectedSubMolecule["name"].split(",")[0],
        user_email: this.email,
      };

      this.homeservice.SalesandVolume(data).subscribe((res) => {
        this.allMoleculeData = res["data"];
        this.ProductData = this.allMoleculeData["product_data"];
        delete this.ProductData["Approval date / Action date (mm-dd-yyyy)"];
        this.DosageForms = this.ProductData["Dosage forms"];

        this.Stregnth = this.allMoleculeData["5 year sales"]["value"];
        this.VolumeStregnth = this.allMoleculeData["5 year volume"]["value"];

        // Collect all possible keys
        this.salesheader = Array.from(new Set(this.Stregnth.flatMap(obj => Object.keys(obj))));
        this.volumeheader = Array.from(new Set(this.VolumeStregnth.flatMap(obj => Object.keys(obj))));

        delete this.allMoleculeData["5 year sales"]["website"];
        delete this.allMoleculeData["5 year volume"]["website"];

        if (res["success"] == "200") {
          this.Molecule = true;
          this.toastService.success("Data Fetched Successfully");
        } else {
          this.toastService.error("Data Not Found!");
        }
      });
    }
  }

  // saveMolecule(
  //   datalist: any,
  //   strength: string,
  //   changeFunction: '5 year sales' | '5 year volume',
  //   mainIndex: number
  // ) {
  //   const headersKey = changeFunction === '5 year sales' ? 'salesheader' : 'volumeheader';
  //   const headers = this[headersKey];

  //   if (!headers) {
  //     console.error(`Missing headers for ${changeFunction}`);
  //     return;
  //   }

  //   const existingRow = datalist[changeFunction].value[mainIndex];
  //   let newValue: any = {};

  //   headers.forEach((key, index) => {
  //     if (key === 'Strengths (mg)' || key === 'Fill Volume/Weight (ml or gm)') {
  //       const val = existingRow[key];
  //       const num = parseFloat(val);
  //       newValue[key] = isNaN(num) ? val : num.toFixed(1);
  //     } else {
  //       const inputId = (changeFunction === '5 year sales' ? 'sales' : 'volume') + mainIndex + 'row' + index;
  //       const inputElement = <HTMLInputElement>document.getElementById(inputId);
  //       if (inputElement) {
  //         let val = parseFloat(inputElement.value || '0');
  //         newValue[key] = isNaN(val) ? 0 : val;
  //       } else {
  //         // fallback to existing value
  //         let val = existingRow[key];
  //         let floatVal = parseFloat(val);
  //         newValue[key] = isNaN(floatVal) ? val : floatVal;
  //       }
  //     }
  //   });

  //   datalist[changeFunction].value[mainIndex] = newValue;
  //   datalist[changeFunction].website = "website0";

  //   const data = {
  //     brand_name: this.selectedSubMolecule["name"].split(",")[0],
  //     nda_number: this.selectedSubMolecule["name"].split(",")[1],
  //     dosage_form: this.DosageForms,
  //     product_data: this.ProductData,
  //     ...datalist,
  //   };

  //   console.log("🚀 Final Payload to Send →", data);
  //   localStorage.setItem("molecules", JSON.stringify(data));

  //   // 🔁 API Call
  //   this.homeservice.UpdateSalesandVolume(data).subscribe(
  //     (response) => {
  //       console.log("response", response);
  //       this.allMoleculeData = response["data"];

  //       if (response["success"] === "200") {
  //         this.toastService.success("Data updated successfully");
  //         this.searchMolecule();
  //         this.showedit = false;
  //         return;
  //       } else {
  //         this.toastService.error("Data not saved!");
  //         this.searchMolecule();
  //         return;
  //       }
  //     },
  //     (error) => {
  //       this.toastService.error(
  //         typeof error === "string" ? error : error.message
  //       );
  //       this.searchMolecule();
  //     }
  //   );
  // }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  editdata(event, row) {
    console.log("rowwwww", row);
    // if (resps === row) {
    //   arr[row] = event.target.value;
    // }
    //   else if (Array.isArray(this.tempData[keys])) {
    //     this.tempData[keys].map((respp, k) => {
    //       if (arr) {
    //         arr.map((resps, p) => {
    //           if (p === row) {
    //             if (resps === trows) {
    //               arr[row] = event.target.value;
    //             }
    //           }
    //         })
    //       } else { }
    //     })
    //   }
  }

  clearFilter() {
    // console.log("in sales and volume")
    // console.log("this molecule", this.Molecule)
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.brandname = '';
    this.subMolecule = false;
    this.MoleculeData1 = null;
    this.nda_number = '';
    this.allMoleculeData = null;
    this.VData = [];
    this.MGData = [];
    this.SalesmainArr = [];
    this.VolumemainArr = [];
    this.ProductData = null;
    this.Stregnth = null;
    this.volumeheader = [];
    this.showedit = false;


    // this.submolecules = [];
    // this.selectedSubMolecule = {};
    // this.Molecule = false;
    // this.searchValue = "";
    // this.subMolecule = false;
    // console.log("after molecule", this.Molecule)

    // this.submolecules = [];
    // this.selectedSubMolecule = {};
    // this.Molecule = false;
    // this.brandname = '';
    // this.subMolecule = false;
    // this.MoleculeData1 = null;
    // this.nda_number = '';
    // this.allMoleculeData = null;
    // this.VData = null;
    // this.MGData = null;
    // this.SalesmainArr = [];
    // this.updateSaleArr = [];
    // this.VolumemainArr = [];
    // this.ProductData = null;
    // this.DosageForms = null;
    // this.Stregnth = null;
    // this.saveData = null;
    // this.SalesVolumeData = null;
    // this.VolumeStregnth = null;
    // this.SalesData = null;
    // this.volumeheader = null;
    // this.showedit = false;
  }
}
